import React from "react";
import Routes from "./Routes";
import FloatingWhatsApp from "./components/ui/FloatingWhatsApp";

function App() {
  return (
    <>
      <Routes />
      <FloatingWhatsApp />
    </>
  );
}

export default App;
